import 'readmore-js';

const Expandable = {
    defaultSelector: '.expandable',
    defaultCollapsedHeight: 150,
    defaultMargin: 16,
    init: ($scope) => {
        const $expandable = $scope || $(Expandable.defaultSelector);

        $expandable.each(function () {
            const $this = $(this);
            const collapsedHeight = $this.data('collapsedHeight')
                ? parseInt($this.data('collapsedHeight'))
                : Expandable.defaultCollapsedHeight;

            if ($this.height() >= collapsedHeight + Expandable.defaultMargin) {
                // collapsedHeight + default margin properties from readmore
                if ($this.find('.gradient-reveal').length === 0) {
                    $this.prepend('<div class="gradient-reveal"></div>');
                }
            }

            $this.readmore({
                collapsedHeight: collapsedHeight,
                blockCSS: '',
                moreLink: '<button type="button" class="btn btn-link read-toggle read-more" href="#"><u>Read more</u> <i class="mdi mdi-plus md"></i></button>',
                lessLink: '<button type="button" class="btn btn-link read-toggle read-less" href="#"><u>Read less</u> <i class="mdi mdi-minus md"></i></button>',
                beforeToggle: function (trigger, element, expanded) {
                    if (!expanded) {
                        $(trigger).prev().children('.gradient-reveal').hide();
                    } else {
                        $(trigger).prev().children('.gradient-reveal').show();
                    }
                },
                afterToggle: function (trigger, element, expanded) {
                    if (expanded) {
                        $(trigger).prev().children('.gradient-reveal').hide();
                    } else {
                        $(trigger).prev().children('.gradient-reveal').show();
                    }
                },
            });
            $(document).on('change', $expandable, function() {
                if ($this.find('.gradient-reveal').length > 0) {
                    $this.prepend('<div class="gradient-reveal"></div>');
                    $(this).readmore('destroy');
                }
            });
        });
    },
};

export default Expandable;
